import React from 'react'
import { useTheme } from '../../../components/ThemeProvider'
import { Title } from '@mantine/core'

const Stamp = ({ text }: { text: string }) => {
  const theme = useTheme()

  return (
    <Title
      order={3}
      style={{
        color: theme.primaryColor,
      }}
    >
      {text}
    </Title>
  )
}

export default Stamp
